import { useMutation } from '@tanstack/react-query'
import { useTranslation } from 'react-i18next'

import { authServices } from '../authServices'
import { SignInDTO, SignInWithEmailPayload } from '../authTypes'

import { ApiErrorCode, ErrorDetail, IOptionsUseMutation } from '@/api/apiTypes'
import { mapAxiosErrorToApiError } from '@/utils'

export const useSignInWithEmail = (
  options?: IOptionsUseMutation<SignInDTO>,
) => {
  const { t } = useTranslation()

  return useMutation<SignInDTO, ErrorDetail, SignInWithEmailPayload>({
    mutationFn: authServices.signInWithEmail,
    onSuccess: (data: SignInDTO) => {
      if (options?.onSuccess) {
        options?.onSuccess(data)
      }
    },
    onError: (err) => {
      const { code } = mapAxiosErrorToApiError(err)
      let errorMessage = t('api:errors.somethingWrong')

      if (code === ApiErrorCode.ACTION_IS_NOT_ALLOWED) {
        errorMessage = t('api:yourAccountIsDeleted')
      }

      if (code === ApiErrorCode.TOO_MANY_ATTEMPTS) {
        errorMessage = t('api:errors.manyAttempts')
      }

      if (options?.onError) {
        options?.onError({ ...err, errorMessage, code })
      }
    },
  })
}
